// src/views/menage/palette-nest.js — les couleurs de l'espace agent, relevées
// sur la maquette NEST v677 (une seule place, pour les deux onglets).
// Règle de la maquette : vert = bon ou fini, aubergine = reste à faire ou à
// regarder, gris = chiffre à lire. Aucun bleu.

export const NEST = {
  encre: '#17211E', gris: '#6B7672', grisTexte: '#5E6A66', grisFonce: '#4F5A56',
  bord: '#E6EAE8', bordCarte: '#E3E8E5', fondCarte: '#F4F6F5', fondFini: '#FAFBFA', fondPage: '#F8F9F8',
  vert: '#0F7A64', vertFonce: '#0B5A49', vertTexte: '#2F6B5C', vertPale: '#E3F1EB', vertLigne: '#E8F3EE',
  vertBord: '#BFDCCF', aub: '#7A2E6E', aubTexte: '#5E2255', aubPale: '#F4E7F1', aubBord: '#DDC2D7',
  grisPale: '#EEF1F0', boutonTexte: '#1C3A33', boutonBord: '#D6DDDA',
}
export const POLICE = "Manrope, -apple-system, 'Segoe UI', sans-serif"
